import { Row, Col } from 'antd';

const GridPresupuestoInicial = ({ budget, budget_iva, iva }) => {

    const numberFormat = new Intl.NumberFormat('es-MX', {minimumFractionDigits: 2});
    console.log("inicial***", budget, iva)
    const budgetIva = budget * (budget_iva/100);
    const budgetIvaPlusIva = (iva/100) * budgetIva;
    const total = budget + budgetIvaPlusIva;

    return (
        <>
            <Col xs={24} md={12}>
                <Row justify="space-between" align="middle" style={{ marginBottom: 12 }}>
                    <h4 className='title-custom'>PRESUPUESTO INICIAL</h4>
                </Row>

                <table style={{ width: "100%", borderSpacing: "0 6px" }}>
                    <tbody>
                    <tr>
                        <td style={{ color: "#98989A", fontWeight: 600, width: "200px" }}>
                        Presupuesto incial:
                        </td>
                        <td style={{ textAlign: "right", fontWeight: 600, width: "120px" }}>
                        $ {numberFormat.format(budget) || "0.00"}
                        </td>
                    </tr>
                    <tr>
                        <td style={{ color: "#98989A", fontWeight: 600 }}>
                        IVA:
                        </td>
                        <td style={{ textAlign: "right", fontWeight: 600, width: "120px" }}>
                        $ {numberFormat.format(budgetIvaPlusIva) || "0.00"}
                        </td>
                    </tr>
                    <tr>
                        <td style={{ color: "#98989A", fontWeight: 600 }}>
                        Total presup. real obra:
                        </td>
                        <td style={{ textAlign: "right", fontWeight: 600, width: "120px" }}>
                        $ {numberFormat.format(total)}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </Col>
        </>
    )
}

export default GridPresupuestoInicial;